import { BoxMonitorBloc } from "./bloc/bloc.box";
import { CloudMonitorBloc } from "./bloc/bloc.cloud";
import { getService } from "@cems-eco/core/src/utils/platform";
import environment from "@/config";

export default getService<BoxMonitorBloc | CloudMonitorBloc>(environment.nexus, {
    box: new BoxMonitorBloc(),
    cloud: new CloudMonitorBloc(),
    demo: new CloudMonitorBloc(),
});